/*
==============================================================================
EVENT TEMPLATE JS v0.1
Presentation Prototype
Backend ticket logic to be added in v0.2
==============================================================================
*/

document.addEventListener("DOMContentLoaded", () => {

  const tabs = document.querySelectorAll(".event-tabs button");
  const panels = document.querySelectorAll(".event-panel");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {

      tabs.forEach(t => t.classList.remove("is-active"));
      tab.classList.add("is-active");

      panels.forEach(p => p.style.display = "none");

      if (panels[index]) {
        panels[index].style.display = "block";
      }

    });
  });

  if (panels.length) {
    panels.forEach((p, i) => {
      p.style.display = i === 0 ? "block" : "none";
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function(e){

      const target = document.querySelector(this.getAttribute("href"));

      if (!target) return;

      e.preventDefault();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    });
  });

  const actionPanel = document.querySelector(".event-template__action-panel");

  if (actionPanel) {

    window.addEventListener("scroll", () => {

      if (window.innerWidth > 990) {

        actionPanel.classList.toggle(
          "is-scrolled",
          window.scrollY > 100
        );

      }

    });

  }

  console.log("Event Template v0.1 Loaded");

}); 